import React, { useState } from 'react';
import '../css/AccordionBlock.css'

function AccordionBlock({ faqList }) {
    const [activeIndex, setActiveIndex] = useState(null);
  
    const toggleAccordion = (index) => {
      setActiveIndex(activeIndex === index ? null : index);
    };
    
  
    return (
      <div className="accordion">
        {faqList.map((item, index) => (
          <div key={index} className="accordion-item">
            <div
              className={`accordion-title ${activeIndex === index ? 'active' : ''}`}
              onClick={() => toggleAccordion(index)}
            >
              <span className="accordion-arrow"></span> {/* Add a span for arrow symbol */}
              <span className="accordion-question">{item.question}</span>
            </div>
            <div className={`accordion-content ${activeIndex === index ? 'active' : ''}`}>
              {item.answer}
            </div>
          </div>
        ))}
      </div>
    );
  }

export default AccordionBlock;
